import { render, staticRenderFns } from "./additional-consent-url-modal.vue?vue&type=template&id=005f6f12&"
import script from "./additional-consent-url-modal.vue?vue&type=script&lang=js&"
export * from "./additional-consent-url-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports